import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=dc9b46ae&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"
import style0 from "./tabs.vue?vue&type=style&index=0&id=dc9b46ae&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9b46ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc9b46ae')) {
      api.createRecord('dc9b46ae', component.options)
    } else {
      api.reload('dc9b46ae', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=dc9b46ae&scoped=true", function () {
      api.rerender('dc9b46ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/accountsPayable/tabs.vue"
export default component.exports